<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import ConfirmDialog from 'primevue/confirmdialog';

const store = useAuthStore();
store.fetchAuthUser();
</script>

<template>
  <div v-if="store.loaded">
    <router-view />
    <ConfirmDialog />
    <Toast />
  </div>

  <div v-else class="bg-white h-screen w-screen flex items-center justify-center relative">
    <img alt="resma" class="mb-8 w-52 shrink-0 mx-auto" src="@/assets/resma.jpg">
    <div class="bg-gray-200 opacity-20 absolute inset-0" />
  </div>
</template>

<style scoped></style>
